import clsx from 'clsx';
import { toast } from 'sonner';

import { Icon } from '../icon';
import { Button } from '../button';

import styles from './toast-notification.module.scss';

const iconMap = {
  warning: 'alert-02-solid',
  error: 'cancel-circle-solid',
  info: 'information-circle-solid',
  success: 'checkmark-circle-02',
  neutral: 'information-circle-solid',
};

export const ToastNotification = (props: ToastNotificationProps) => {
  const { id, type = 'success', title, description, action, icon, iconMultiColor = false, showCloseButton = true } = props;

  const iconType = icon ?? iconMap[type];

  return (
    <div
      className={clsx(type, styles.toastNotification, styles[type], {
        [styles.fixedWidth]: !!description || !!action,
      })}
    >
      <ul className={styles.toastHeader}>
        <li>
          <Icon type={iconType} multiColor={iconMultiColor} className={styles.typeIcon} size={20} />
        </li>
        <li>
          <span className={clsx(styles.title, 'ellipsis-text')}>{title}</span>
        </li>
        {showCloseButton && (
          <li>
            <button
              type="button"
              className={styles.closeBtn}
              onClick={() => toast.dismiss(id)}
              aria-label="Close toast notification"
            >
              <Icon type="cancel-01" size={18} />
            </button>
          </li>
        )}
      </ul>
      {(!!description || !!action) && (
        <div className={styles.content}>
          {!!description && <div className={clsx(styles.description, 'ellipsis-text')}>{description}</div>}
          {!!action && (
            <div className={styles.footer}>
              <Button
                size="small"
                onClick={() => {
                  action.onClick();
                  toast.dismiss(id);
                }}
                cornerRadius="smooth"
                color="dark"
              >
                {action.label}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export interface ToastNotificationProps {
  icon?: string;
  title: string;
  id: number | string;
  description?: string;
  iconMultiColor?: boolean;
  showCloseButton?: boolean;
  action?: ToastNotificationAction;
  type?: 'success' | 'info' | 'warning' | 'error' | 'neutral';
}

export interface ToastNotificationAction {
  label: string;
  onClick: () => void;
}
